import VueRouter from 'vue-router'

export const routes = [
  {
    path: '/',
    component: () => import('./components/WebGL/Canvas/LandingCanvas.vue')
  },
  {
    path: '/menu',
    redirect: '/wheel'
  },
  {
    path: '/wheel',
    redirect: '/'
  },
  {
    path: '/art',
    component: () => import('./components/WebGL/Canvas/ArtCanvas.vue')
  },
  {
    path: '/dance',
    component: () => import('./components/WebGL/Canvas/DanceCanvas.vue')
  },
  {
    path: '/game',
    component: () => import('./components/WebGL/Canvas/GamePlayCanvas.vue')
  },
  {
    path: '/city',
    component: () => import('./components/WebGL/Canvas/CityCanvas.vue')
  },
  {
    path: '/building',
    component: () => import('./components/WebGL/Canvas/CodeBuildingCanvas.vue')
  },
  {
    path: '/church',
    component: () => import('./components/WebGL/Canvas/ChurchCanvas.vue')
  },
  {
    path: '/isocity',
    component: () => import('./components/WebGL/Canvas/IsoCityCanvas.vue')
  },

  {
    path: '/demo',
    component: () => import('./components/WebGL/Canvas/MenuCanvas.vue')
  },
  {
    path: '/embed/fame',
    component: () => import('./components/WebGL/HTMLContent/EnergyFlame/EnergyGame.vue')
  },
  {
    path: '/examples',
    component: () => import('./components/WebGL/HTMLContent/MenuBar/Docs.vue'),
    children: [
      {
        path: 'swat',
        label: 'Boxing',
        component: () => import('./components/WebGL/HTMLContent/Demo/DemoSwat.vue')
      },
      {
        path: 'spaceship',
        label: 'Spaceship',
        component: () => import('./components/WebGL/HTMLContent/Demo/DemoSpaceship.vue')
      },
      {
        path: 'church',
        label: 'Church',
        component: () => import('./components/WebGL/HTMLContent/Demo/DemoChurch.vue')
      },
      {
        path: 'glassman',
        label: 'Glassman',
        component: () => import('./components/WebGL/HTMLContent/Demo/DemoGlassman.vue')
      },
      {
        path: 'flame',
        label: 'Energy Flame',
        component: () => import('./components/WebGL/HTMLContent/EnergyFlame/EnergyFlame.vue')
      },
      {
        path: 'energy-game',
        label: 'Energy Flow',
        component: () => import('./components/WebGL/HTMLContent/EnergyFlame/EnergyGame.vue')
      },
      {
        path: 'energy-flower',
        label: 'Energy Flower',
        component: () => import('./components/WebGL/HTMLContent/EnergyFlame/EnergyFlower.vue')
      }
      // {
      //   path: 'super-nano-demo',
      //   label: 'Supernano Demo',
      //   component: () => import('./components/WebGL/HTMLContent/SupernanoDemo/SupernanoDemo.vue')
      // }
    ],
  },
  {
    path: '/doc',
    component: () => import('./components/WebGL/HTMLContent/MenuBar/Docs.vue'),
    children: [
      {
        path: 'welcome',
        label: 'Welcome',
        component: () => import('./components/WebGL/HTMLContent/Docs/DDWelcome.vue')
      },
      {
        path: 'overview',
        label: 'Code Overview',
        component: () => import('./components/WebGL/HTMLContent/Docs/DDOverview.vue')
      },
      {
        path: 'quick-start',
        label: 'Quick Start',
        component: () => import('./components/WebGL/HTMLContent/Docs/DDQuickStart.vue')
      },
      {
        path: 'folder-structure',
        label: 'Folder Strucutre',
        component: () => import('./components/WebGL/HTMLContent/Docs/DDFolder.vue')
      },
      {
        path: 'editor',
        label: 'LIVE Layout Editor',
        component: () => import('./components/WebGL/HTMLContent/Docs/DDEditor.vue')
      },
      {
        path: 'credits',
        label: 'Credits',
        component: () => import('./components/WebGL/HTMLContent/Docs/DDCredits.vue')
      },
      {
        path: 'friends',
        label: 'Friendly Links',
        component: () => import('./components/WebGL/HTMLContent/Docs/DDFriendlyLinks.vue')
      },
      {
        path: 'matcaps',
        label: 'Material Capture',
        component: () => import('./components/WebGL/HTMLContent/MatCapLib/MatCapLib.vue')
      }
    ],
  },
  {
    path: '*',
    redirect: '/'
  }
]

export const router = new VueRouter({
  mode: 'history',
  routes
})
